export default __webpack_public_path__ + "static/media/poster.b46ef3a1.jpeg";